const hasPermission = (state, getters, rootState, rootGetters) => {
    return rootGetters['auth/appAccesses']?.includes('MIA');
};

export default {
    hasPermission,
};
